import { ChangeEvent, useState } from 'react';

export type AddressFormState = {
  shipAddress1: string;
  shipAddress2: string;
  shipCity: string;
  shipState: string;
  shipZipCode: string;
  shipCountry: string;
};

export default function useHandleFormInput() {
  const initialFormState: AddressFormState = {
    shipCountry: '',
    shipAddress1: '',
    shipAddress2: '',
    shipCity: '',
    shipState: '',
    shipZipCode: '',
  };
  const [formState, setFormState] = useState(initialFormState);
  const handleOnChange = (event:
  ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
    const property = event.target.name;
    const updatedFormState = {
      ...formState,
      ...{ [property]: event.target.value },
    };
    setFormState(updatedFormState);
  };
  return {
    formState,
    handleOnChange,
    setFormState,
  };
}
